import { useState, useRef } from 'react'
import { RECORD_STATUS } from './status'
import useTimer from './useTimer'
import MicRecorder from './mic-recorder';


export const useAudioRecorder = ({ nameFile }) => {
  const recorder = useRef(new MicRecorder({ bitRate: 128 }));

  const [status, setStatus] = useState(RECORD_STATUS.IDLE)
  const [audioResult, setAudioResult] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')

  const {
    timer,
    handleStartTimer,
    handlePauseTimer,
    handleResumeTimer,
    handleResetTimer
  } = useTimer()

  const startRecording = () => {
    if (status === RECORD_STATUS.IDLE) {
      try {
        setErrorMessage('')
        recorder.current.start().then(() => {
          handleStartTimer();
          setStatus(RECORD_STATUS.RECORDING);
        }).catch((error) => {
          setErrorMessage(error?.message)
        })
      } catch (error) {
        setErrorMessage("Vui lòng mở micro");
        console.log(error)
      }
    } else {
      return
    }
  }

  const resumeRecording = () => {
    if (status === RECORD_STATUS.PAUSED) {
      recorder.current.resume();
      handleResumeTimer();
      setStatus(RECORD_STATUS.PAUSED);
    } else {
      return
    }
  }

  const pauseRecording = () => {
    if (status === RECORD_STATUS.RECORDING) {
      recorder.current.pause();
      handlePauseTimer()
      setStatus(RECORD_STATUS.PAUSED)
    } else {
      return
    }
  }

  const resetAudio = () => {
    setAudioResult(null)
  }

  const stopRecording = () => {
    if (status !== RECORD_STATUS.IDLE) {
      handleResetTimer();
      recorder.current.stop().getMp3().then(([buffer, blob]) => {
        console.log(buffer, blob);
        const file = new File(buffer, nameFile || 'Phat-bieu-can-bo.mp3', {
          type: blob.type,
          lastModified: Date.now()
        });
        setAudioResult(file)
        setStatus(RECORD_STATUS.IDLE)
      }).catch((e) => {
        console.error(e);
      });
    } else {
      return null
    }
  }

  return {
    resetAudio,
    startRecording,
    stopRecording,
    pauseRecording,
    resumeRecording,
    status,
    audioResult,
    errorMessage,
    timer
  }
}
